$(document).ready(function () {
    require('./slider')()
    require('./zoom-gallery')()
    require('./modals')()
})